<app-ds-autocomplete
	[label]="label"
	[placeholder]="placeholder"
	[hint]="currentHint"
	[required]="required"
	[disabled]="isDisabledByDependencies"
	[loading]="isLoadingZonas"
	[options]="zonas"
	[displayWith]="displayZona"
	[value]="selectedZona"
	(valueChange)="onValueChange($event)"
	(touched)="onControlTouched()"
></app-ds-autocomplete>
